module.exports = __webpack_public_path__ + "img/jpg02_fwsxq.e5bfe0fb.png";